import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { FormBuilder } from '@angular/forms';
import {
  CONFIGURACION_DISPOSITIVOS,
  ConfiguracionDispositivo,
} from 'src/app/administracion/constants/configuracion-dispositivos.const';
import { isEmpty, omitBy } from 'lodash';
import { Modelo } from 'src/app/administracion/modelos/Inventario/Modelo/modelo';
import { Tipo } from 'src/app/administracion/modelos/Inventario/Tipo/tipo';
import { Fabricante } from 'src/app/administracion/modelos/Inventario/Fabricante/fabricante';
import { EquipoService } from 'src/app/administracion/servicios/Inventario/Equipo/equipo.service';
import { TablasDispositivos } from 'src/app/administracion/enums/tablas-dispositivos.enum';
import { distinctUntilChanged, finalize, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { EstadosEquipos } from 'src/app/administracion/enums/estados-equipos.enum';
import { EstadosGestion } from 'src/app/administracion/enums/estados-gestion.enum';

@Component({
  selector: 'app-reporte-filtros',
  templateUrl: './reporte-filtros.component.html',
  styleUrls: ['./reporte-filtros.component.scss'],
})
export class ReporteFiltrosComponent implements OnInit, OnDestroy {
  @Input() disabled: boolean = false;

  @Output() filtrosAplicados = new EventEmitter<any>();

  readonly configuracionDispositivos = CONFIGURACION_DISPOSITIVOS;

  private readonly onDestroy$ = new Subject<void>();

  estados = Object.values(EstadosGestion);

  cargandoModelos = false;
  modelos: Modelo[] = [];

  cargandoFabricantes = false;
  fabricantes: Fabricante[] = [];

  cargandoTipos = false;
  tiposDispositivos: Tipo[] = [];

  filtrosForm = this.fb.group({
    dispositivo: [],
    tipoEquipo: [''],
    estatus: [''],
    etiqueta: [''],
    marca: [''],
    modelo: [''],
    numSerie: [''],
    colaboradorAsignado: [''],
    // fechaAsignacion: this.fb.group({
    //   inicio: [null],
    //   fin: [null],
    // }),
    // fechaAlta: this.fb.group({
    //   inicio: [null],
    //   fin: [null],
    // }),
    // fechaBaja: this.fb.group({
    //   inicio: [null],
    //   fin: [null],
    // }),
  });

  constructor(
    private readonly fb: FormBuilder,
    private readonly equipoService: EquipoService,
  ) {}

  ngOnInit(): void {
    this.onTipoDispositivoChange();
    this.filtrosForm.controls['dispositivo'].setValue(
      this.configuracionDispositivos.COMPUTADORAS,
    );
    this.obtenerFabricantes();
    this.aplicarFiltros();
  }

  ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }

  aplicarFiltros() {
    const { dispositivo, ...filtros } = this.filtrosForm.getRawValue();
    this.filtrosAplicados.emit(
      omitBy({ tabla: dispositivo.tabla, ...filtros }, isEmpty),
    );
  }

  limpiarFiltros() {
    this.filtrosForm.reset({
      dispositivo: this.configuracionDispositivos.COMPUTADORAS,
    });
    this.aplicarFiltros();
  }

  onTipoDispositivoChange() {
    this.filtrosForm.controls['dispositivo'].valueChanges
      .pipe(distinctUntilChanged(), takeUntil(this.onDestroy$))
      .subscribe((dispositivo: ConfiguracionDispositivo) => {
        this.obtenerTipos(dispositivo.tablaTipo);
        this.obtenerModelos(dispositivo.tablaModelo);
      });
  }

  obtenerFabricantes() {
    if (this.cargandoFabricantes) return;

    this.cargandoFabricantes = true;

    this.equipoService
      .obtenerEquipos(TablasDispositivos.Manufacturer)
      .pipe(
        finalize(() => (this.cargandoFabricantes = false)),
        takeUntil(this.onDestroy$),
      )
      .subscribe((data) => {
        this.fabricantes = data.content;
      });
  }

  obtenerModelos(tabla: string) {
    if (this.cargandoModelos) return;

    this.cargandoModelos = true;

    this.equipoService
      .obtenerEquipos(tabla)
      .pipe(
        finalize(() => (this.cargandoModelos = false)),
        takeUntil(this.onDestroy$),
      )
      .subscribe((data) => {
        this.modelos = data.content;
      });
  }

  obtenerTipos(tabla: string) {
    if (this.cargandoTipos) return;

    this.cargandoTipos = true;

    this.equipoService
      .obtenerEquipos(tabla)
      .pipe(
        finalize(() => (this.cargandoTipos = false)),
        takeUntil(this.onDestroy$),
      )
      .subscribe((data) => {
        this.tiposDispositivos = data.content;
      });
  }
}
